module.exports = __webpack_public_path__ + "media/images/TRANSPORT-bbae6262471c8733fb518c56b9817dde.svg";